import { cx } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const DangerousHtmlContent = ({
  className,
  component: Component = 'div',
  content,
  customRef,
  dataTestId,
  ...rest
}) => /*#__PURE__*/_jsx(Component, {
  className: cx('etiHtmlContent', className),
  dangerouslySetInnerHTML: {
    __html: content
  },
  "data-testid": dataTestId,
  ref: customRef,
  ...rest
});
export default DangerousHtmlContent;
//# sourceMappingURL=DangerousHtmlContent.js.map